import React from 'react'
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router'
import { cn } from './utils.js'

export interface LinkProps extends RouterLinkProps {
	className?: string
	children: React.ReactNode
}

export function Link({ className, children, onClick, ...props }: LinkProps) {
	const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		// Scroll to top when navigating
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'instant' as ScrollBehavior
		})
		document.documentElement.scrollTop = 0
		document.body.scrollTop = 0
		
		// Call original onClick if provided
		if (onClick) {
			onClick(e)
		}
	}

	return (
		<RouterLink className={cn('cursor-pointer', className)} onClick={handleClick} {...props}>
			{children}
		</RouterLink>
	)
}
